import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=1c915d88&"
import script from "./PageSettings.vue?vue&type=script&lang=js&"
export * from "./PageSettings.vue?vue&type=script&lang=js&"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=1c915d88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports